// extracted by mini-css-extract-plugin
export default {"container":"view-on-vehicle-button__container___1gNol","vov-button-label":"view-on-vehicle-button__vov-button-label___QFA_x","car-icon":"view-on-vehicle-button__car-icon___i7haz"};